<template>
	<div class="controlpanel-page controlpanel-page-pdt0">
    <div class="uploadreporttopbar">
			<h1>数据管理 - 数据上传</h1>
			<el-divider></el-divider>
    </div>
		<div class="controlpanel-container controlpanel-container-upload">
      <form :action="uploadurl" method="post" enctype="multipart/form-data" target="_blank" class="upload-form">
					<div class="upload-form-item"><span>数据月份</span><input type="text" name="yearMonth" placeholder="eg:2021-04"></div>
					<div class="upload-form-item"><span>进口 - 美元</span><input type="file" name="import_usd"></div>
					<div class="upload-form-item"><span>进口 - 人民币</span><input type="file" name="import_rmb"></div>
					<div class="upload-form-item"><span>出口 - 美元</span><input type="file" name="export_usd"></div>
					<div class="upload-form-item"><span>出口 - 人民币</span><input type="file" name="export_rmb"></div>
					<div class="upload-form-item">
          <input type="submit" value="上传">
        </div>
      </form>
    </div>
	</div>
</template>

<script>
export default {
  data(){
    return{
			uploadurl: ''
    }
  },

	mounted(){
    this.setUploadUrl()
	},

	methods: {
		onSubmit: function(){
			console.log(this.formData)
		},

    setUploadUrl: function(){
      let url = 'http://dashboard.api.trade-intelligence.com/admin/raw/upload'+'?token='+this.getLocalStorage('admintoken')+''
      this.uploadurl = url
    },
	}
}
</script>